import { useNavigate } from '@tanstack/react-router'
import { useTelegram } from '@/shared/lib/telegram'
import { Coffee, Plus, Heart, Package } from 'lucide-react'
import { cn } from '@/shared/lib/utils'

/**
 * Быстрые действия профиля
 * 
 * 4 основные кнопки действий. CSS-анимации, без задержек.
 */
export function ProfileActionsGrid() {
  const navigate = useNavigate()
  const { hapticFeedback } = useTelegram()

  const actions = [
    {
      id: 'add-entry',
      label: 'Новая запись',
      icon: Plus,
      path: '/tea-diary/add',
      accent: true,
    },
    {
      id: 'diary',
      label: 'Дневник',
      icon: Coffee,
      path: '/tea-diary',
    },
    {
      id: 'favorites',
      label: 'Избранное',
      icon: Heart,
      path: '/want-to-drink',
    },
    {
      id: 'orders',
      label: 'Заказы',
      icon: Package,
      path: '/orders',
    },
  ]

  const handleClick = (path: string) => {
    hapticFeedback.impactOccurred('light')
    navigate({ to: path as any })
  }

  return (
    <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 delay-75">
      <div className="grid grid-cols-4 gap-2">
        {actions.map((action) => {
          const Icon = action.icon
          return (
            <button
              key={action.id}
              onClick={() => handleClick(action.path)}
              className={cn(
                'flex flex-col items-center justify-center gap-1.5 p-3 rounded-xl',
                'transition-all duration-150 active:scale-95',
                action.accent
                  ? 'bg-primary text-white shadow-sm'
                  : 'bg-white dark:bg-dark-card text-ink dark:text-white shadow-sm hover:shadow-md'
              )}
            >
              <Icon className="w-5 h-5" strokeWidth={1.5} />
              <span className="text-[11px] font-medium text-center leading-tight">
                {action.label}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
